class FAQs extends HTMLElement {
  constructor() {
    super();

    this.filter = document.getElementById('haloFAQsFilter');
    this.faqsPopup = document.getElementById('halo-faqs-popup');

    if (this.filter) {
      this.filterToggle = this.filter.querySelector('[data-faqs-filter]');
      this.filterDropdown = this.filter.querySelector('.faqs-filterDropdown-menu');
      this.filterDropdownArrow = this.filterToggle?.querySelector('[data-dropdown-arrow]');

      if (this.filterToggle) {
        this.filterToggle.addEventListener('click', this.onClickFilterHandler.bind(this));
      }

      if (this.filterDropdown?.querySelector('.text')) {
        this.filterDropdown.querySelectorAll('.text').forEach((filterButton) => {
          filterButton.addEventListener('click', this.onClickFilterButtonHandler.bind(this));
        });
      }
    }

    if (this.querySelector('.faqs')) {
      this.querySelectorAll('.card-header').forEach((headerButton) => {
        headerButton.addEventListener('click', this.onClickHeaderButtonHandler.bind(this));
      });
    }

    if (!document.body.classList.contains('template-index')) {
      document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }
  }

  // --- filtre ---
  onClickFilterHandler() {
    if (!this.filterDropdown) return;
    const show = this.filterDropdown.classList.toggle('is-show');
    this.filterDropdownArrow?.classList.toggle('active', show);
  }

  onClickFilterButtonHandler(event) {
    const btn = event.target.closest('li');
    if (!btn || btn.classList.contains('is-active')) return;

    const filterValue = btn.getAttribute('data-value');
    const filterText = event.target.innerText;

    this.filterToggle?.querySelector('.text')?.replaceChildren(document.createTextNode(filterText));

    this.filterDropdown.querySelectorAll('li').forEach((el) => el.classList.remove('is-active'));
    btn.classList.add('is-active');

    if (filterValue !== undefined && filterValue !== null) {
      this.querySelectorAll('.faqs-paragraph').forEach((el) => {
        const id = el.getAttribute('id');
        if (id == filterValue) {
          el.classList.remove('is-hidden');
          el.classList.add('is-active');
        } else {
          el.classList.remove('is-active');
          el.classList.add('is-hidden');
        }
      });
    } else {
      this.querySelectorAll('.faqs-paragraph').forEach((el) => {
        el.classList.remove('is-hidden', 'is-active');
      });
    }

    this.filterDropdown.classList.remove('is-show');
    this.filterDropdownArrow?.classList.remove('active');
  }

  // --- TEK AÇIK cevap: önce hepsini kapat, sonra tıklananı aç ---
  onClickHeaderButtonHandler(event) {
    const btn = event.currentTarget;            // tıklanan başlık (.card-header)
    const content = btn.nextElementSibling;     // cevap içeriği (accordion body)

    // 1) Tüm diğerlerini KAPAT
    this.querySelectorAll('.card-header').forEach((h) => {
      const c = h.nextElementSibling;
      if (c && c.style) c.style.maxHeight = null;
      h.classList.add('collapsed');
    });

    // 2) Sadece tıklananı AÇ
    btn.classList.remove('collapsed');
    if (content && content.style) {
      // scrollHeight dinamik olabilir; önce null'layıp sonra set etmek iyi olur
      content.style.maxHeight = null;
      content.style.maxHeight = content.scrollHeight + 'px';
    }
  }

  onBodyClickEvent(event) {
    if (!this.filterDropdown) return;
    if (event.target.closest('[data-faqs-filter]') != null) return;
    if (this.filterDropdown.classList.contains('is-show')) {
      this.filterDropdown.classList.remove('is-show');
      this.filterDropdownArrow?.classList.remove('active');
    }
  }
}

customElements.define('faqs-item', FAQs);
